import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { GraduationCap } from "@phosphor-icons/react";

export default function ShortLink() {
  const { code } = useParams();
  const nav = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/l/${code}`)
      .then((r) => nav(r.data.target_path || "/", { replace: true }))
      .catch(() => setError(true));
  }, [code, nav]);

  return (
    <div className="grid min-h-screen place-items-center bg-background grain">
      <div className="text-center">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-primary text-primary-foreground animate-pulse"><GraduationCap size={28} weight="fill" /></span>
        <p className="mt-4 text-muted-foreground">{error ? "This link could not be found." : "Redirecting you…"}</p>
      </div>
    </div>
  );
}
